import { Star, Phone, CalendarCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { REVIEWS, BUSINESS } from "@/lib/constants";

export default function Reviews() {
  return (
    <div data-testid="reviews-page" className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="text-center">
        <div className="flex justify-center gap-1 text-gold mb-2">
          {[1,2,3,4,5].map(i => <Star key={i} className="w-8 h-8 fill-gold text-gold" />)}
        </div>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold text-black">4.9 Google Rating</h1>
        <p className="mt-4 text-xl text-gray-700">Honest reviews from Alberta drivers we've helped.</p>
      </div>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {REVIEWS.map((r, i) => (
          <div key={i} data-testid={`review-${i}`} className="bg-white border border-slate-200 rounded-lg p-6 shadow-sm">
            <div className="flex gap-1 text-gold">
              {[1,2,3,4,5].map(s => <Star key={s} className="w-5 h-5 fill-gold text-gold" />)}
            </div>
            <div className="mt-2 text-sm font-semibold uppercase tracking-wider text-gold">{r.theme}</div>
            <p className="mt-3 text-lg text-gray-900 leading-relaxed">"{r.text}"</p>
            <p className="mt-4 font-semibold text-black">— {r.name}</p>
          </div>
        ))}
      </div>

      <div className="mt-16 bg-white border-t border-slate-200 pt-12 text-center">
        <h2 className="font-heading text-3xl font-bold text-black">Ready to join our happy clients?</h2>
        <div className="mt-6 flex flex-col sm:flex-row justify-center gap-3">
          <Link to="/consultation" className="btn-primary" data-testid="reviews-consult-btn"><CalendarCheck className="w-5 h-5" /> Book Free Consultation</Link>
          <a href={`tel:${BUSINESS.phoneRaw}`} className="btn-primary" data-testid="reviews-call-btn">
            <Phone className="w-5 h-5" /> Call {BUSINESS.phone}
          </a>
        </div>
      </div>
    </div>
  );
}
